(ns practitest.frontend.tests.index
  (:require [practitest.frontend.common-entities :refer [batch-navigate!
                                                         batch-open-in-new-tab!
                                                         common-index-grid-props
                                                         grid-columns]
             :as common-entities]
            [practitest.frontend.common-entities.events :as common-events]
            [practitest.frontend.common-entities.index :refer [index-content-panel] :as common-index]
            [practitest.frontend.common-entities.metadata :as metadata]
            [practitest.frontend.common.format-utils :as fu]
            [practitest.frontend.common.i18n :refer [format-translation
                                                     get-translation] :as i18n]
            [practitest.frontend.common.mixpanel :as mixpanel]
            [practitest.frontend.common.permissions :as permissions]
            [practitest.frontend.common.re-frame :refer [partial-dispatch
                                                         partial-subscribe]]
            [practitest.frontend.components.grid.events :as grid.events]
            [practitest.frontend.components.grid.subs :as grid.subs]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components2.entity-form.forms :as forms]
            [practitest.frontend.components2.grid :as grid2]
            [practitest.frontend.components2.grid.fields :refer [transform-fields]]
            [practitest.frontend.components2.grid.row-menu :refer [row-menu]]
            [practitest.frontend.events :as events]
            [practitest.frontend.folders :as folders]
            [practitest.frontend.routing.backend-routes :as broutes]
            [practitest.frontend.subs :as subs]
            [practitest.frontend.tests.events :as tests-events]
            [practitest.frontend.tests.link-testsets :as link-testsets]
            [practitest.frontend.tests.batch-set-version-label :as batch-version-label]
            [practitest.frontend.common.dom :as dom]
            [re-frame.core :as re-frame]))

(def edit-permission "tests_editor")
(def admin-permission "tests_admin")

(def current-entity :test)
(def table-id (get-in metadata/entities-metadata [current-entity :table-id]))
(def include-descending? true)
(def state-key tests-events/tests-index-state-key)


(def main-controller
  {:start    (fn [params]
               (re-frame/dispatch [::events/set-current-entity-type current-entity])
               (re-frame/dispatch [::folders/fetch-folders current-entity include-descending?]))
   :identity :parameters})

(defn dropdown-actions-menu [selection versioning-enabled?]
  (let [disabled? (not (permissions/has-permission? edit-permission))
        button-disabled? (grid.subs/empty-selection? selection)
        current-view @(re-frame/subscribe [::grid.subs/current-view :test state-key])
        track-fn #(mixpanel/track "Grid Actions" {"Action" %})
        filters (common-index/get-entity-filters current-entity)
        opts {:entity current-entity
              :state-key state-key
              :selection selection
              :current-view current-view
              :optional-params {:filter filters}}]
    [common-index/dropdown-actions-menu
      [{:text (get-translation "entity.button.find_and_replace" "Find & Replace")
        :on-click (fn []
                    (track-fn "Find & Replace")
                    (common-events/batch-navigate-guarded
                     (assoc opts :path (broutes/get-url-view "tests#find_and_replace"))))
        :icon [icons/find-and-replace]
        :disabled? (or button-disabled? versioning-enabled?)}
       {:text (get-translation "generic.button.delete" "Delete")
        :on-click #(common-events/batch-navigate-guarded
                    (assoc opts :path (broutes/get-url-view "tests#batch_delete")))
        :icon [icons/mux-trash]
        :disabled? button-disabled?}
       {:text (get-translation "generic.button.print" "Print")
        :on-click (fn []
                    (track-fn "Print")
                    (batch-open-in-new-tab!
                       (broutes/get-url-view "qtest_designs#print") selection current-view {:filter filters}))
        :icon [icons/printer]
        :disabled? button-disabled?}
       {:text (get-translation "generic.button.clone" "Clone")
        :icon [icons/mux-copy]
        :disabled? button-disabled?
        :on-click (fn []
                    (track-fn "Clone Test")
                    (common-events/batch-navigate-guarded
                     (assoc opts :path (broutes/get-url-view "tests#batch_clone"))))}
       {:disabled? button-disabled?
        :test-id "tests-grid-create-testset"
        :on-click (let [create-testset-uri (broutes/get-url-view "common#create_testset")]
                    (fn []
                      (track-fn "New Test Set")
                      (batch-navigate! create-testset-uri selection current-view {:entity "Test"})))
        :text (get-translation "entity.button.create-testset" "New Test Set")
       :icon [icons/mux-testsets-runs]}]
      disabled?]))

(defn grid-buttons []
  (let [has-edit-permissions? (permissions/has-permission? edit-permission)
        selection @(re-frame/subscribe [::grid.subs/selection [:test state-key]])
        current-view @(re-frame/subscribe [::grid.subs/current-view :test state-key])
        no-selection? (grid.subs/empty-selection? selection)
        versioning-enabled? @(re-frame/subscribe [::subs/test-case-versioning-enabled?])
        versioning-can-use-labels? @(re-frame/subscribe [::subs/versioning-can-use-labels?])]
    [:div.entities-grid-toolbar.all-available-width
     [common-index/grid-buttons
      (filterv some?
        [(when versioning-enabled?
           (common-index/batch-version-label-button-data current-entity selection current-view state-key has-edit-permissions? versioning-can-use-labels?))
         {:disabled? (or no-selection? (not has-edit-permissions?))
          :test-id "tests-grid-add-test-to-testset"
          :on-click #(do (link-testsets/show-linked-entities-dialog)
                         (mixpanel/track "Grid Actions" {"Action" "Add to Test Set"}))
          :class "hide-text"
          :icon [icons/mux-testsets-runs]
          :text (get-translation "test.button.add-test-to-testset" "Add to Test Set")
          :title (get-translation "test.button.add-test-to-testset" "Add to Test Set")}
         (common-index/batch-edit-button-data current-entity selection current-view state-key has-edit-permissions?)
         (common-index/new-entity-button-data current-entity)])]
     (dropdown-actions-menu selection versioning-enabled?)]))

(re-frame/reg-sub
  ::filter_columns
  :<- [::subs/entity :test]
  (fn [entity [_ state-key]]
    (get-in entity [state-key :filter-cols])))

(def default-columns
  (get-in metadata/entities-metadata [current-entity :default-columns]))

(defmethod grid.subs/columns :test-columns [[_current-project entity-fields fields users groups folders] [_ [_entity _]]]
  (concat
   [{:type :test_type
     :field :test_type
     :header (get-translation "test.label.type" "Type")
     :autofilter? true}
    {:type :url
     :field :name
     :default-width 200
     :autofilter? true
     :header (get-translation "generic.label.name" "Name")}
    {:type          :linked-entities
     :default-width 200
     :autofilter?   false
     :sortable?     false
     :header        (get-translation "issue.linked" "Linked Issues")
     :field         :linked_issues}
    {:type          :linked-entities
     :default-width 200
     :autofilter?   false
     :sortable?     false
     :header        (get-translation "requirement.linked" "Linked Requirements")
     :field         :linked_requirements}
    {:type          :linked-entities
     :default-width 200
     :header        (get-translation "testset.linked" "Linked Test Sets")
     :autofilter?   false
     :sortable?     false
     :field         :linked_testsets}
    {:type          :number
     :field         :steps_count
     :autofilter?   true
     :text-align    "center"
     :multiple?     true
     :sortable?     true
     :header        (get-translation "test.label.steps-count" "Steps Count")}]
   (transform-fields []
                     (dissoc (:test entity-fields) :description :test_type)
                     fields users groups folders)))

(defn entities-grid [grid-state]
  (let [current-tab               (re-frame/subscribe [::grid.subs/current-tab current-entity state-key])
        has-edit-permissions      (permissions/has-permission? edit-permission)
        has-admin-permissions      (permissions/has-permission? admin-permission)
        columns-id (get-in metadata/entities-metadata [current-entity :columns-id])
        all-columns (concat default-columns
                            (grid-columns @(re-frame/subscribe [::grid.subs/columns [current-entity columns-id]])
                                          @(re-frame/subscribe [::filter_columns state-key])))
        grid-props {:columns      (map #(assoc % :default-show? true) all-columns)
                    :post-columns [{:header        ""
                                    :field         :actions
                                    :default-width 50
                                    :width         50
                                    :type          :custom
                                    :text-align    :center
                                    :resizable?    false
                                    :sortable?     false
                                    :systemcol?    true
                                    :class         ["action-menu"]
                                    :cell-fn       (fn [_ row]
                                                     [row-menu row (or (not has-edit-permissions)
                                                                       (:edit_locked row))
                                                      [{:label    (get-translation "generic.button.edit" "Edit")
                                                        :icon     icons/mux-pencil
                                                        :href     (:url row)
                                                        :disabled?    (or (not has-edit-permissions)
                                                                          (:edit_locked row))
                                                           ;; TODO: fix this
                                                        :on-click (fn [])}

                                                       {:label        (get-translation "generic.button.delete" "Delete")
                                                        :icon         icons/mux-trash
                                                        :disabled?    (not has-admin-permissions)
                                                        :on-click     (fn []
                                                                        (mixpanel/track "Grid Actions" {"Action" "Delete Test"})
                                                                        (re-frame/dispatch [::common-events/delete-entity (:id row) state-key grid-state]))
                                                        :confirmation {:title     (get-translation "test.confirm.delete.title"
                                                                                                   "Delete Test?")
                                                                       :body      (format-translation
                                                                                   (get-translation "entity.confirm.delete.body"
                                                                                                    "\"%{object-name}\" will be deleted permanently.")
                                                                                   :object-name (fu/truncate-text (:title row) 30))
                                                                       :yes-label (get-translation "generic.button.delete"
                                                                                                   "Delete")
                                                                       :no-label  (get-translation "generic.button.cancel"
                                                                                                   "Cancel")}}

                                                       {:label    (get-translation "generic.button.print" "Print")
                                                        :icon     icons/printer
                                                        :disabled? false
                                                        :on-click (fn []
                                                                    (mixpanel/track "Grid Actions" {"Action" "Print Test"})
                                                                    (batch-open-in-new-tab! (broutes/get-url-view "qtest_designs#print") #{(:id row)} nil))}

                                                       {:label    (get-translation "generic.button.clone" "Clone")
                                                        :icon     icons/mux-copy
                                                        :disabled? (not has-edit-permissions)
                                                        :on-click (fn []
                                                                    (mixpanel/track "Grid Actions" {"Action" "Clone Test"})
                                                                    (dom/form-navigate! (broutes/get-url-view "qtest_designs#clone_entity" {:id (:id row)}) {"_method" "post"}))}

                                                       {:label    (get-translation "entity.button.create-testset" "New Test Set")
                                                        :icon     icons/mux-testsets-runs
                                                        :disabled? (not has-edit-permissions)  
                                                        :on-click (fn []
                                                                    (mixpanel/track "Grid Actions" {"Action" "New Test Set"})
                                                                    (batch-navigate! (broutes/get-url-view "common#create_testset") #{(:id row)} nil {:entity "Test"}))}

                                                       {:label    (get-translation "test.button.add-test-to-testset" "Add to Test Set")
                                                        :icon     icons/mux-testsets-runs
                                                        :disabled? (not has-edit-permissions)  
                                                        :on-click (fn []
                                                                    (mixpanel/track "Grid Actions" {"Action" "Add to Test Set"})
                                                                    (re-frame/dispatch [::grid.events/select-one [current-entity state-key] (:id row)])
                                                                    (link-testsets/show-linked-entities-dialog))}]])}]

                    :loading?              @(re-frame/subscribe [::subs/progress? ::common-events/fetch-entity-list])
                    :grid-state            grid-state  ; TODO: Check if can be removed because :local-state-updating
                    :local-state-updating  grid-state
                    :toggle-selection      (partial-dispatch [::grid.events/toggle-selection [current-entity state-key]])
                    :toggle-selection-page (partial-dispatch [::grid.events/toggle-selection-page [current-entity state-key]])
                    :on-query-changed      (if (= @current-tab "filters")
                                             (partial-dispatch [::common-events/fetch-entity-list current-entity state-key])
                                             (partial-dispatch [::common-events/fetch-entity-list-by-folder current-entity state-key]))
                       ;; For filters
                    :get-field-props       (partial-subscribe [::forms/field-props :test])
                    :grid-toolbar          grid-buttons
                    :on-expand-click       (partial-dispatch [::common-events/toggle-expanded current-entity state-key])
                    :expanded?             @(re-frame/subscribe [::grid.subs/expanded? current-entity state-key])
                    :current-view           @current-tab
                    :show-save-fast-filter? true}
        grid-props (merge (common-index-grid-props current-entity state-key table-id)
                          grid-props)]
    [:div.entities-grid {:class (when (:expanded? grid-props) "col")}
     [link-testsets/linked-entities-dialog type]
     [batch-version-label/batch-version-label-modal]
     [batch-version-label/bdd-message-modal]
     [grid2/grid grid-props]]))

(defn index []
  [index-content-panel {:module "Test" :current-entity current-entity :state-key state-key :entities-grid entities-grid}])


(defn ^:export init [options]
  (let [{:keys [translation]} (-> options (js->clj :keywordize-keys true))]
    (i18n/append-translation! @(re-frame/subscribe [::subs/current-locale]) translation)))